import React from 'react';
import { withApollo } from "react-apollo";

import { updateNote } from '../../graphql/mutations';

class NoteTextarea extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			id: props.id,
			body: props.body
		};

		this.timeout = null;

    	this.handleChange = this.handleChange.bind(this);
    	this.mutate = this.mutate.bind(this);
	}

	componentDidMount(){
	 //  this.textarea.focus(); 
	}

	handleChange(e) {

		this.setState({ body: e.target.value });
		
		clearTimeout(this.timeout);
		this.timeout = setTimeout(this.mutate,  250);
	}

	mutate() {
		const state = {
			id: this.state.id,
			body: this.state.body
		}
		this.props.client.mutate({
			mutation: updateNote,
			variables: state
		})
		.catch(e => {
			alert('Note Error: ' + e);
		});
	}
	
	render() {
		return (
      		<textarea className="noteTextarea" 
      			ref={(input) => { this.textarea = input; }} 
      			value={this.state.body}
      			onChange={this.handleChange}></textarea>
      	)
	}
}

export default withApollo(NoteTextarea)


// WEBPACK FOOTER //
// ./src/components/note/NoteTextarea.js